export const DEFAULT_BATCH_YEAR = parseInt(process.env.REACT_APP_DEFAULT_BATCH_YEAR) || 2026;

// Always shows the 4 most recent batch years ending at the default year.
// Change REACT_APP_DEFAULT_BATCH_YEAR in .env each year — this array updates automatically.
export const BATCH_OPTIONS = [
  DEFAULT_BATCH_YEAR - 3,
  DEFAULT_BATCH_YEAR - 2,
  DEFAULT_BATCH_YEAR - 1,
  DEFAULT_BATCH_YEAR,
];

// Course enum — must match the backend enum integer values.
// Pass these numeric values in all ?course= query params.
export const SUBJECTS_ENUM = {
  Maths: 1,
  Science: 2,
  Physics: 3,
  Chemistry: 4,
  English: 5,
};
